import { render, staticRenderFns } from "./companyForm.component.vue?vue&type=template&id=fc162976&"
import script from "./companyForm.component.vue?vue&type=script&lang=js&"
export * from "./companyForm.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports